import { Builder } from '@builder.io/react';

import Pricing from './index';

Builder.registerComponent(Pricing, {
  name: 'Pricing Section',
  inputs: [
    {
      name: 'table',
      type: 'object',
      subFields: [
        {
          name: 'labels',
          type: 'list',
          defaultValue: [{ name: 'label' }],
          subFields: [
            {
              name: 'name',
              type: 'string'
            }
          ]
        },
        {
          name: 'tabs',
          type: 'list',
          defaultValue: [
            {
              overtitle: 'Team'
            }
          ],
          subFields: [
            { name: 'overtitle', type: 'string' },
            { name: 'title', type: 'string' },
            {
              name: 'pricing',
              type: 'object',
              subFields: [
                { name: 'price', type: 'string' },
                { name: 'rate', type: 'string' },
                { name: 'disclaimer', type: 'string' }
              ]
            },
            { name: 'description', type: 'longText' },
            {
              name: 'primaryColor',
              type: 'string',
              enum: ['gray-700', 'scale-lightskyblue', 'scale-lightmauve', 'gradient-x'],
              defaultValue: 'scale-lightmauve'
            },
            {
              name: 'secondaryColor',
              type: 'string',
              enum: [
                'gray-700',
                'scale-lightskyblue',
                'scale-mauve',
                'scale-lightmauve',
                'gradient-x'
              ],
              defaultValue: 'scale-lightmauve'
            },
            {
              name: 'cta',
              type: 'object',
              subFields: [
                {
                  name: 'buttons',
                  type: 'list',
                  defaultValue: [
                    {
                      text: 'Get Started',
                      href: '/sales',
                      type: 'primary'
                    }
                  ],
                  subFields: [
                    {
                      name: 'text',
                      type: 'string'
                    },
                    {
                      name: 'href',
                      type: 'url'
                    },
                    {
                      name: 'type',
                      type: 'string',
                      defaultValue: 'primary',
                      enum: ['primary', 'secondary']
                    },
                    {
                      name: 'variant',
                      type: 'string',
                      defaultValue: 'default',
                      enum: ['default', 'transparent']
                    }
                  ]
                },
                {
                  name: 'hubspotModal',
                  type: 'object',
                  subFields: [
                    {
                      name: 'formId',
                      type: 'string'
                    },
                    {
                      name: 'sfdcCampaignId',
                      type: 'string'
                    },
                    {
                      name: 'label',
                      type: 'string'
                    }
                  ]
                }
              ]
            },
            {
              name: 'showCtaOnTop',
              type: 'boolean',
              defaultValue: 'false'
            },
            {
              name: 'ctaDescription',
              type: 'longText'
            },
            { name: 'features', type: 'list', subFields: [{ name: 'text', type: 'longText' }] },
            { name: 'entries', type: 'list', subFields: [{ name: 'text', type: 'longText' }] }
          ]
        }
      ]
    },
    {
      name: 'disclaimer',
      type: 'text'
    }
  ]
});
